import { render, staticRenderFns } from "./MypageMarginPage.vue?vue&type=template&id=4b9e2e56&scoped=true&"
import script from "./MypageMarginPage.vue?vue&type=script&lang=js&"
export * from "./MypageMarginPage.vue?vue&type=script&lang=js&"
import style0 from "./MypageMarginPage.vue?vue&type=style&index=0&id=4b9e2e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9e2e56",
  null
  
)

export default component.exports